import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ReservationFlight, ReservationHotel } from '@user-history/entities/history-booking-detail';
import { ReservationType } from '@user-history/entities/user-history-item';
import { PackageReservationFlightFormatPipe } from '@app/pipes/package-reservation-format.pipe';
import { IMAGE_TYPE } from '@ux/components/image/constants/image-type.constants';
import { TravelDetailProvider } from '@shared/flight-itinerary/entities/travel-detail-provider';
import { AirValidationSectorVm } from '@app/entities/air-validation.response';
import { AbandonedReservationsAbstract } from '@abandoned-reservation/abstracts/abandoned-reservations.abstract';

@Component({
  selector: 'app-abandoned-air-package-reservation',
  templateUrl: './abandoned-air-package-reservation.component.html',
  styleUrls: ['./abandoned-air-package-reservation.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})

export class AbandonedAirPackageReservationComponent extends AbandonedReservationsAbstract {

  public typeImageHotel: string = IMAGE_TYPE.HOTEL;
  public summaryProvider: TravelDetailProvider = TravelDetailProvider.BOOKING_FLIGHT;

  constructor(
    private formatReservation: PackageReservationFlightFormatPipe
  ) {
    super()
  }

  get airReservationItem(): ReservationFlight {
    return this.hasReservationDetail ? this.formatReservation.transform(
      (this.itinerary.Reservations as ReservationFlight[])
        .find(reservation => reservation.ReservationType === ReservationType.Flight)) : {} as ReservationFlight;
  }

  get hotelReservationItem(): ReservationHotel {
    return this.hasReservationDetail ? (this.itinerary.Reservations as ReservationHotel[])
      .find(reservation => reservation.ReservationType === ReservationType.Hotel) : {} as ReservationHotel;
  }

  get sectors(): AirValidationSectorVm[] {
    return this.airReservationItem?.Sectors ? this.airReservationItem?.Sectors.map(sector => ({
      ...sector,
      FlightItem: {
        DepartureAirport: sector.Flights[0].DepartureAirport,
        ArrivalAirport: sector.Flights[sector.Flights.length - 1].ArrivalAirport,
        AirlineCode: sector.Flights[0].AirlineCode,
        AirlineName: sector.Flights[0].AirlineName,
        DepartureDate: sector.Flights[0].DepartureDate,
        ArrivalDate: sector.Flights[sector.Flights.length - 1].ArrivalDate,
        SectorNumber: sector.SectorNumber
      }
    })) : [];
  }

  private get hasReservationDetail(): boolean {
    return !!this.itinerary?.Reservations;
  }

}
